import { FuelImpact } from "@labs/shared/types/AnalyzedPlan.ts";

export const filterFuelImpacts = (fuelImpacts: FuelImpact[]): FuelImpact[] =>
  fuelImpacts.filter((impact) => impact.carbonImpact !== 0);
